import { supabase } from "@/integrations/supabase/client";

const SESSION_ID_KEY = "cena_chat_session_id";

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
}

export type EventType =
  | "landing_search"
  | "inquiry_submitted";

/**
 * Zaloguje událost do Supabase (tabulka events). Nepřerušuje běh při chybě.
 */
export async function logEvent(
  eventType: EventType,
  payload?: Record<string, unknown>
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    const sessionId = getSessionId();
    await supabase.from("events").insert({
      event_type: eventType,
      payload: payload ?? {},
      user_id: user?.id ?? null,
      session_id: sessionId,
    });
  } catch (e) {
    console.warn("events.logEvent failed:", e);
  }
}
